import {action, computed, observable} from 'mobx';
import isEmpty from 'lodash/isEmpty';
import device from 'current-device';
import {PlatformMode, StudioDrawerState} from '../../constants/enums';
import looperStore from '../create/looper/store';
import {isStudent} from '../../utils/userUtility';
import {isMobile, isTablet} from '../../utils/screenUtility';

class MainStore {
    @observable showToast = false;
    @observable showMainProgressLoader = false;
    @observable isShowUploadLoader = false;
    @observable showMainAppDrawer = false;
    @observable platformMode = PlatformMode.Home;
    @observable studioDrawerState = StudioDrawerState.None;
    @observable isStemsAnimationEnd = true;
    @observable focusLessonTitle = false;
    @observable showPromoButton = true;
    @observable deviceOrientation = device.orientation;
    @observable needToRefresh = false;
    @observable anchorNotificationRef = null;

    constructor() {
        device.onChangeOrientation(action((newOrientation) => {
            this.deviceOrientation = newOrientation;
        }));
    }

    
    @computed get isNeedToRefresh() {
        return this.needToRefresh;
    }

    @computed get isPortrait() {
        return this.deviceOrientation === "portrait"
    }

    @computed get isTabletPortrait() {
        return this.isPortrait && isTablet();
    }

    @computed get isMobilePortrait() {
        return this.isPortrait && isMobile();
    }

    @computed get isMobileLandscape() {
        return !this.isPortrait && isMobile();
    }

    @computed get isMainAppDrawerOpen() {
        return this.showMainAppDrawer;
    }

    @computed get isShowMainAppDrawerBtn() {
        const {parentOwnerId, assignedUsers, assignedToAll} = looperStore.loopedProject;
        return this.platformMode !== PlatformMode.Home && looperStore.loopedProject && parentOwnerId && (isStudent() || isEmpty(assignedUsers) || assignedToAll);
    }

    @computed get isLoading() {
        return this.showMainProgressLoader;
    }

    @computed get isUpload() {
        return this.isShowUploadLoader;
    }

    @computed get isViewMode() {
        return this.platformMode === PlatformMode.View;
    }

    @computed get isEditMode() {
        return this.platformMode === PlatformMode.Edit;
    }

    @computed get isHomeMode() {
        return this.platformMode === PlatformMode.Home;
    }

    @computed get isCreateMode() {
        return this.platformMode === PlatformMode.Create;
    }

    @action toggleProgressLoader = (value) => {
        this.showMainProgressLoader = value;
    };

    @action hideProgressLoader = () => {
        this.showMainProgressLoader = false;
    };

    @action showProgressLoader = () => {
        this.showMainProgressLoader = true;
    };

    @action hideUploadLoader = () => {
        this.isShowUploadLoader = false;
    };

    @action showUploadLoader = () => {
        this.isShowUploadLoader = true;
    };

    @action toggleToast = (value) => {
        this.showToast = value;
    };

    @action closeMainAppDrawer = () => {
        this.showMainAppDrawer = false;
    };


    @action openMainAppDrawer = () => {
        this.showMainAppDrawer = true;
    };

    @action setChatAnchorRef = (anchorRef) => {
        this.anchorNotificationRef = anchorRef;
    }

    @action toggleMainAppDrawer = () => {
        this.showMainAppDrawer = !this.showMainAppDrawer;
    };

    @action updatePlatformMode = (mode) => {
        this.platformMode = mode;
    };

    @action setStudioDrawerState = (state) => {
        this.studioDrawerState = state;
    };

    @action setFocusLessonTitle = (val) => {
        this.focusLessonTitle = val;
    };

    @action finishStemsAnimation = (val) => {
        this.isStemsAnimationEnd = val;
    };

    @action setShowPromoButton = (val) => {
        this.showPromoButton = val;
    }

    @action setNeedToRefresh = (val) => {
        console.log('Got refresh request');
        this.needToRefresh = val;
    }
}

const mainStore = new MainStore();
export default mainStore;
